import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { arrayDifference } from 'utils/helpers'
import {
    getFileThumbnails,
    getFileIndicators,
    thumbnailSelector,
} from 'features/patient-file-thumbnail/thumbnailSlice'
import Thumbnail from './Thumbnail'

const ThumbnailsContainer = ({ filter, files, handleFavorite, handleSelectFile, handleClick }) => {
    const reduxDispatch = useDispatch()
    const [filteredFiles, setFilteredFiles] = useState([])

    const thumbnailCache = useSelector(state => thumbnailSelector.selectIds(state))
    const { isLoading, indicatorsCache } = useSelector(state => state.thumbnails)

    useEffect(() => {
        if (filteredFiles?.length) {
            const thumbnailIds = filteredFiles.map(f => f.thumbnailId).filter(f => f)
            const thumbnailDiff = arrayDifference(thumbnailIds, thumbnailCache)
            const fileIds = filteredFiles.map(f => f.fileId)
            const fileDiff = arrayDifference(fileIds, indicatorsCache)

            if (thumbnailIds.length && thumbnailDiff.length) {
                reduxDispatch(getFileThumbnails(thumbnailDiff.join()))
            }
            if (fileIds.length && fileDiff.length) {
                reduxDispatch(getFileIndicators({ ids: fileDiff.join() }))
            }
        }
    }, [filteredFiles])

    useEffect(() => {
        if (files) {
            let filtered = files
            if (filter !== 'all') {
                filtered = files.filter(f => f.fileType.toLowerCase() === filter)
            }

            setFilteredFiles(filtered)
        }
        return () => setFilteredFiles([])
    }, [files, filter])

    return (
        <>
            {filteredFiles.length > 0 &&
                filteredFiles.map(file => {
                    return (
                        <Thumbnail
                            data={file}
                            key={file.fileId}
                            handleSelectFile={handleSelectFile}
                            isLoading={isLoading}
                            handleFavorite={handleFavorite}
                            handleClick={handleClick}
                        />
                    )
                })}
        </>
    )
}

export default ThumbnailsContainer
